import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import './dashboard.css';

/**
 * 登录后访问 /dashboard 的分发器（class-stream Phase B，设计文档 §5.2）。
 *
 * - 无班级企业（enterprise_classes_enabled === false）→ 全员看板
 *   /dashboard/enterprises/{id}
 * - 启用班级企业 / 跨企业管理员（admin·superadmin 无 enterprise）
 *   → /dashboard/classes（ClassListPage 内部再解析默认班 / 渲染列表）
 *
 * enterprise_classes_enabled 由 /api/auth/me/ 提供（UserSerializer）。
 */
export default function DashboardEntryRedirect() {
  const { user, loading } = useAuth();

  if (loading) {
    return <div className="aiq-dash dash-page"><div className="dash-card">正在打开看板...</div></div>;
  }

  // 超管 / 系统管理员（跨企业、无所属企业）→ 企业选择器列表。
  if (user && !user.enterprise_id && ['superadmin', 'admin'].includes(user.role)) {
    return <Navigate to="/dashboard/enterprises" replace />;
  }

  if (user && user.enterprise_id && user.enterprise_classes_enabled === false) {
    return <Navigate to={`/dashboard/enterprises/${user.enterprise_id}`} replace />;
  }
  return <Navigate to="/dashboard/classes" replace />;
}
